export default __webpack_public_path__ + "17b478e647e75c80dff6ee97ca1b33b6.gif";